import type { i18n as I18nInstance } from 'i18next';

import cs from './locales/cs.json';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import pt from './locales/pt.json';

/**
 * The i18next namespace the renderer node/card components read from.
 * Kept package-owned (rather than Kaleidoscope's `admin_bizy`) so the
 * catalog travels with the components and both apps stay self-contained.
 */
export const BIZY_KIT_I18N_NAMESPACE = 'bizyKit';

export const bizyKitTranslations: Record<string, Record<string, unknown>> = {
	en,
	cs,
	de,
	es,
	fr,
	it,
	pt,
};

/**
 * Merges the bundled bizy-kit translation catalog into a host i18next
 * instance under the {@link BIZY_KIT_I18N_NAMESPACE} namespace. Call once
 * during app setup (after the host has initialized i18next).
 *
 * Existing host keys win (`deep`/no-overwrite) so an app can override a
 * string by adding it to the same namespace before calling this.
 */
export function registerBizyKitTranslations(i18n: I18nInstance): void {
	for (const [language, resources] of Object.entries(bizyKitTranslations)) {
		i18n.addResourceBundle(language, BIZY_KIT_I18N_NAMESPACE, resources, true, false);
	}
}
